<template>
  <section class="mine-menu-card">
    <button
      v-for="(item, index) in mineItemList"
      :key="index"
      type="button"
      class="mine-menu-card__row"
      :class="{ 'mine-menu-card__row--danger': item.to === 'Logout' }"
      @click="onCellClick(item.to)"
    >
      <span class="mine-menu-card__icon" aria-hidden="true">
        <van-icon :name="item.icon" />
      </span>
      <span class="mine-menu-card__title">{{ item.title }}</span>
      <van-icon name="arrow" class="mine-menu-card__arrow" aria-hidden="true" />
    </button>
  </section>
</template>

<script>
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { showConfirmDialog } from "vant";
import { logout } from "@/utils/localStorageUtils";

export default {
  name: "NewMineItemRedesign",
  props: {
    mineItemList: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const router = useRouter();
    const { t } = useI18n();

    const onCellClick = (toPath) => {
      if (toPath == "Logout") {
        showConfirmDialog({
          message: t("app.logout.title"),
          confirmButtonText: t("app.logout.confirm"),
          cancelButtonText: t("app.logout.cancel"),
        })
          .then(() => {
            logout();
            router.replace({ name: "Login" });
          })
          .catch(() => {});
        return;
      }
      if (toPath == "Login") {
        logout();
        router.replace({ name: "Login" });
        return;
      }

      // 商品购买入口：微信内置浏览器无法完成后续支付宝支付，弹提示（点「我知道了」消失），不跳转
      if (
        toPath === "ConsumerRetailerList" &&
        /MicroMessenger/i.test(navigator.userAgent)
      ) {
        showConfirmDialog({
          title: t("app.consumerorder.alipay_wechat_guide_title"),
          message: t("app.mineitem.wechat_purchase_hint"),
          confirmButtonText: t("app.consumerorder.alipay_wechat_pay_confirm"),
          showCancelButton: false,
        })
          .then(() => {})
          .catch(() => {});
        return;
      }

      router.push({ name: toPath });
    };

    return { onCellClick };
  },
};
</script>

<style lang="scss" scoped>
$green: #009343;
$green-light: #e8f5ed;
$surface: #ffffff;
$ink: #1a1f1c;
$ink-secondary: #3d4540;
$label: #8a9490;
$border: #e8edea;
$required: #e53935;
$card-radius: 0.12rem;
$shadow-card: 0 0.02rem 0.08rem rgba(13, 40, 24, 0.08);
$ease-out: cubic-bezier(0.22, 1, 0.36, 1);

.mine-menu-card {
  background: $surface;
  border-radius: $card-radius;
  box-shadow: $shadow-card;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  text-align: left;

  &__row {
    display: flex;
    align-items: center;
    gap: 0.1rem;
    width: 100%;
    min-height: 0.48rem;
    padding: 0.12rem 0.14rem;
    border: none;
    border-bottom: 0.01rem solid $border;
    background: transparent;
    cursor: pointer;
    text-align: left;
    transition: background 0.15s $ease-out;

    &:last-child {
      border-bottom: none;
    }

    &:active {
      background: $green-light;
    }

    &--danger {
      .mine-menu-card__title {
        color: $required;
      }

      .mine-menu-card__icon {
        background: rgba(229, 57, 53, 0.08);
        color: $required;
      }
    }
  }

  &__icon {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 0.32rem;
    height: 0.32rem;
    border-radius: 0.1rem;
    background: $green-light;
    color: $green;
    font-size: 0.16rem;
  }

  &__title {
    flex: 1;
    min-width: 0;
    font-size: 0.14rem;
    font-weight: 500;
    color: $ink-secondary;
    line-height: 1.4;
    text-align: left;
  }

  &__arrow {
    flex-shrink: 0;
    font-size: 0.14rem;
    color: $label;
  }
}

@media (prefers-reduced-motion: reduce) {
  .mine-menu-card__row {
    transition: none;
  }
}
</style>
